import { Component, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { EventsService, UtilService } from 'src/app/shared/services';
// import { NgxGlideModule } from 'ngx-glide';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-our-success-stories',
  standalone: true,
  imports: [
    CommonModule,
    SwiperModule,
    // NgxGlideModule,
    MatButtonModule
  ],
  templateUrl: './our-success-stories.component.html',
  styleUrls: ['./our-success-stories.component.scss']
})
export class OurSuccessStoriesComponent {
  info = {
    title: 'Our Success Stories',
    videoList: [
      { id: 1, isPaused: true,  url: 'https://ketto-media-prod.s3.ap-southeast-1.amazonaws.com/3/videos/Thanks+to+your+support-+my+child+was+able+to+survive+premature+birth..mp4' },
      { id: 2, isPaused: true, url: 'https://ketto-media-prod.s3.ap-southeast-1.amazonaws.com/3/videos/You+Angels+Gifted+Kauteelya+A+New+Life!.mp4' },
      { id: 3, isPaused: true, url: 'https://ketto-media-prod.s3.ap-southeast-1.amazonaws.com/3/videos/Thanks+for+giving+my+child+a+healthy+and+happy+life!.mp4' },
    ],
    socialContent: {
      title: 'Witness more stories of impact!',
      desc: 'Follow us on our social handles'
    }
  }

  isMobile;

  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    initialSlide: 1,
    navigation: true,
    keyboard: false,
    scrollbar: false,
    loop: false,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
      waitForTransition: true
    },
    observer: true,
    preloadImages: false,
    spaceBetween: 8,
    centeredSlides: false,
    pagination: true,
    breakpoints: {
      992: {
        slidesPerView: 1,
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
          waitForTransition: true
        },
        observer: true,
      },
      768: {
        slidesPerView: 1,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
          waitForTransition: true
        },
        initialSlide: 1,
      }
    }
  };


  constructor(
    private util: UtilService,
    private elRef: ElementRef,
    private events: EventsService
  ) {}

  ngOnInit() {
    this.isMobile = this.util.isMobile();
  }

  playVideo(event, item) {
    const videoEl = event.target.parentElement.parentElement.firstChild;
    if (videoEl.classList.contains('playing')) {
      videoEl.pause();
    } else {
      videoEl.play();
    }
    item.isPaused = !item.isPaused;
    videoEl.classList.toggle('playing');
    this.events.sendSystemEvent({
      eventName: 'click_on_tab',
      page_name: this.util.vars.pageName,
      info_1: 'video_success'
    }).subscribe(_ => _);
  }

  onSocialMediaClicked(choice) {
    if (this.util.isBrowser) {
      const ch = {
        fb: 'https://www.facebook.com/profile.php?id=100064806753864',
        ig: 'https://www.instagram.com/kettoindia/'
      }
      window.open(ch[choice]);
    }
  }
  onSwipeEnded() {
    if (typeof window !== 'undefined') {
      const videoElList = this.elRef.nativeElement.querySelectorAll('video');
      videoElList.forEach((item, index) => {
        if (!item.paused) {
          item.pause();
          this.info.videoList[index].isPaused = !this.info.videoList[index].isPaused;
        }
      });
    }
  }
}
